export const headerCellTitlesOfData = [
  {'name': 'Product code', 'serializedName': 'productCode', 'width': '75px', 'required': true, 'maxLength': '4'},
  {'name': 'Factor PVP', 'serializedName': 'factorRetail', 'width': '140px', 'required': true},
  {'name': 'Factor PVP 1', 'serializedName': 'factorRetail1', 'width': '140px'},
  {'name': 'Factor PVP 2', 'serializedName': 'factorRetail2', 'width': '140px'},
  {'name': 'Factor PVP 3', 'serializedName': 'factorRetail3', 'width': '140px'},
  {'name': 'Factor PVP 4', 'serializedName': 'factorRetail4', 'width': '140px'},
  {'name': 'Factor TDE', 'serializedName': 'factorWholesale', 'width': '140px', 'required': true},
  {'name': 'Factor TDE 1', 'serializedName': 'factorWholesale1', 'width': '140px'},
  {'name': 'Factor TDE 2', 'serializedName': 'factorWholesale2', 'width': '140px'},
  {'name': 'Factor TDE 3', 'serializedName': 'factorWholesale3', 'width': '140px'},
  {'name': 'Factor TDE 4', 'serializedName': 'factorWholesale4', 'width': '140px'},
  {'name': 'Grupo', 'serializedName': 'tdeGroup', 'width': '100px', 'required': true, 'maxLength': '100'},
  {'name': 'Descripción grupo', 'serializedName': 'groupDescription', 'width': '100px',
    'required': true, 'maxLength': '100'},
];

export const headerCellTitlesOfControl = [
  {'name': 'Acciones', 'width': '80px'},
];
